module.exports = __webpack_public_path__ + "static/media/right-side.0c1bfc86.png";